import React, { cloneElement } from 'react'
import { Route } from 'react-router-dom'

import useSmartBanner from 'hooks/useSmartBanner'
import General from 'layouts/General'

const PublicRoute = ({ children, ...rest }) => {
  useSmartBanner()

  return (
    <Route
      {...rest}
      render={props => <General {...rest}>{cloneElement(children, props)}</General>}
    />
  )
}

export default PublicRoute
